<app-table-header
  (reload)="onRefreshList(false)"
  [loading]="loading"
  [withExportOption]="!!data.info.exportTableName"
  (exportBtnClicked)="exportBtnClicked()"
  >
  <button nz-button nzType="primary" class="new-export-button" (click)="newExportModalComponentRef.showModal()">
    <i nz-icon nzType="plus-circle" nzTheme="outline"></i><span>Neuer Export</span>
  </button>
  <app-table-search-bar (search)="search($event)" [searchValue]="currentSearch"></app-table-search-bar>
</app-table-header>
<nz-table appColumnLayout
  #tableRef
  nzShowSizeChanger
  [nzScroll]="{ x: '1200px' }"
  [nzData]="data.results"
  [nzLoading]="loading"
  [nzTotal]="data.info.totalResults"
  [nzFrontPagination]="false"
  [nzPageSize]="pageSize"
  [nzPageIndex]="data.info.page"
  (nzQueryParams)="onQueryParamsChange($event)"
  appKeepState
  id="generated-documents-list-table"
  >
  <thead>
    <tr>
      <th nzColumnKey="visibleName" [nzSortFn]="true" nzWidth="280px">Name</th>
      <th nzColumnKey="type" [nzSortFn]="true" nzWidth="260px">Typ</th>
      <th nzColumnKey="outputType" [nzSortFn]="true" nzWidth="110px">Dateityp</th>
      <th nzColumnKey="comment" [nzSortFn]="true" nzWidth="200px">Kommentar</th>
      <th nzColumnKey="user.fullName" [nzSortFn]="true" nzWidth="180px">Mitarbeiter</th>
      <th nzColumnKey="createdAt" [nzSortFn]="true" nzWidth="160px">Erstellt am</th>
      <th nzColumnKey="actions" nzWidth="160px" nzRight></th>
    </tr>
  </thead>
  <tbody>
    @for (doc of data.results; track doc.documentKey) {
      <tr>
        <td>{{ doc | exportDocumentName }}</td>
        <td>{{ doc.type | exportTypeLabel }}</td>
        <td class="cell-nowrap">{{ documentTypes[doc.outputType] ? (documentTypes[doc.outputType] | uppercase) : '–' }}</td>
        <td>{{ doc.comment || '–' }}</td>
        <td>{{ doc.user?.fullName || '–' }}</td>
        <td class="cell-nowrap">{{ doc.createdAt | datetimeFormat }}</td>
        <td nzRight>
          <div class="actions">
            @if (doc.outputType === documentTypes.Pdf) {
              <app-download-document [documentKey]="doc.documentKey" text="Herunterladen"></app-download-document>
            }
            @if (doc.outputType === documentTypes.Csv) {
              <app-download-csv
                [documentKey]="doc.documentKey"
                [fileName]="doc.documentKey"
                text="Herunterladen"
              ></app-download-csv>
            }
          </div>
        </td>
      </tr>
    }
  </tbody>
</nz-table>

<app-export-table-modal #exportTableModalComponent></app-export-table-modal>

<app-new-export-modal #newExportModalComponentRef></app-new-export-modal>
